
import * as React from "react";
const { useEffect } = React;
import { useAuth } from '@/contexts/auth';
import { useToast } from '@/hooks/use-toast';
import { useStableMobileDetection } from '@/hooks/useStableMobileDetection';
import { MobileErrorBoundary } from '@/components/ui/MobileErrorBoundary';
import { LAYERS } from '@/utils/layers';

interface PrayerCompanionProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function PrayerCompanion({ visible, onClose, children }: PrayerCompanionProps) {
  const { isAuthenticated } = useAuth();
  const { toast } = useToast();
  const { availableHeight } = useStableMobileDetection();

  // Close on Escape
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    if (visible) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [visible, onClose]);

  // Lock body scroll when companion is visible
  useEffect(() => {
    if (visible) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [visible]);

  console.log('🎯 PrayerCompanion render check:', { visible, isAuthenticated });
  
  if (!visible) return null;

  // No more custom height calculations - use universal CSS classes

  return (
    <MobileErrorBoundary>
      <div className="prayer-companion-container">
        <div className="bg-white dark:bg-gray-800 shadow-xl w-full h-full flex flex-col sa-inset">
          {children}
        </div>
      </div>
    </MobileErrorBoundary>
  );
}
